import { XIcon } from "lucide-react";
import { IAlert } from "../../interfaces";
import { getGaAlertIcon } from "../../utils/gaiaUtils";
import { ResponseTypeEnum } from "../../utils/constants";

export const GaAlert = ({ alert, clearAlert }: { alert: IAlert, clearAlert?: () => any }) => {
    const canBeCleared = !alert.sticky && clearAlert !== undefined;

    const handleClick = () => {
        if (canBeCleared)
            clearAlert();
    }

    if (!alert.type) alert.type = ResponseTypeEnum.Danger;

    var gaAlertType = alert.type.toString();
    switch (alert.type) {
        case "info":
            gaAlertType = "information";
            break;
        case "danger": 
            gaAlertType = "error";
            break;
        default:
            gaAlertType = alert.type ? alert.type.toString() : "";
            break;
    }

    const iconClassName = alert.title ? "" : "ga-ar-mt-0";

    return (
        <div className={`ga-notification ga-notification--${gaAlertType} ${alert.className ? alert.className : ""} ga-m-tb-04`} onClick={() => handleClick()}>
            {getGaAlertIcon(gaAlertType, iconClassName)}
            <div className="ga-notification__content">
                {alert.title &&
                    <div className="ga-notification__heading">
                        <div className="ga-notification__title">
                            {alert.title}
                        </div>
                    </div>
                }
                {alert.message &&
                    <p className="ga-notification__description">
                        {alert.message}
                    </p>
                }
            </div>
            {canBeCleared && 
                <button type="button" className="ga-button ga-button--icon-only ga-button--ghost">
                    <XIcon />
                </button>
            }
        </div>
    );
};
